
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/Schedule/Schedule.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./Schedule.html');
        
        var script = require('./Schedule.ts').default;
        module.exports = require('./Schedule.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    